/**
 * Pure builders for the discover-feed request. Kept separate so the circle vs
 * public routing (a past source of bugs) is unit-testable in isolation.
 */

/**
 * feed-genre-filter — the chip standing for "no style could be resolved".
 * It is a selection value in the UI but never a style on the wire.
 */
export const UNCLASSIFIED_STYLE = 'unclassified';

/**
 * A specific private circle → its own recos (`groupId`). Racore Official /
 * public feed (`includePublic`) → the public `is_public` recos. This mirrors
 * the backend `/recommendation/feed` contract.
 */
export function buildFeedQuery(
  page: number,
  groupId?: number | null,
  includePublic?: boolean,
  pageSize = 25,
  styles?: readonly string[],
): URLSearchParams {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  if (groupId && !includePublic) {
    params.set('groupId', String(groupId));
  } else {
    params.set('includePublic', 'true');
  }

  // feed-genre-filter — the chips are a UNION. "Unclassified" is not a style:
  // it is the absence of one, so it travels as its own flag. Nothing is emitted
  // when nothing is selected, so an unfiltered request stays byte-for-byte what
  // it has always been.
  const selected = styles ?? [];
  const realStyles = selected.filter((s) => s !== UNCLASSIFIED_STYLE);
  if (realStyles.length > 0) params.set('styles', realStyles.join(','));
  if (selected.includes(UNCLASSIFIED_STYLE)) params.set('includeUnclassified', 'true');

  return params;
}
